import { Loading } from '@bumble/app/components/Loading';
import { TabGrid, TabGridStructure } from '@bumble/app/components/TabGrid';
import { useApi } from '@bumble/app/hooks/use-api';
import { useQuery } from '@tanstack/react-query';

interface DisplayContactsProps {
  id: string;
}

const DisplayContacts = ({ id }: DisplayContactsProps) => {
  const api = useApi();
  const { isLoading, data } = useQuery(
    ['getEpContacts'],
    api.getContactByEpIdApiV1GetContactByEpIdGet.bind(null, { ep_id: id }),
    { enabled: true },
  );
  const tabDataContacts: TabGridStructure[] = [
    { label: 'Business Contact', content: data?.data?.primary_contact || 'N/A' },
    { label: 'Technical Contact', content: data?.data?.secondary_contact || 'N/A' },
  ];
  if (isLoading) return <Loading />;
  return (
    <TabGrid data={tabDataContacts} colWidth={12} />
  );
};

export default DisplayContacts;